//--------------------------
// is campaign note changed
//--------------------------
export default function isCampaignNoteChanged(original, now) {
  console.log('----------------------------')
  console.log('IN isCampaignNoteChanged')

  console.log('ORIGINAL CAMPAIGN NOTE: ', original)
  console.log('NOW CAMPAIGN NOTE: ', now)

  if (original.note != now.note) {
    console.log('NOTE CHANGED ', original.note)
    return true
  } else if (original.session_date != now.session_date) {
    console.log('SESSION DATE CHANGED ', original.session_date)
    return true
  } else {
    console.log('VALUE NOT CHANGED ', original.note)
    return false
  }
}
